<template>
  <div>
    <div class="row">
      <div class="col-md-7">
        <div class="block block-rounded block-themed">
          <div class="block-header bg-gd-emerald">
            <h3 class="block-title">{{ $t('app.free_information') }}</h3>
            <div class="block-options">
              <span
                  class="badge badge-pill badge-danger"
                  v-if="debt.risk_amount > 0 && debt.risk_date >= today">
                В зоне риска до {{ debt.risk_date | dateFormat }}
              </span>
              <span
                  class="badge badge-pill badge-warning"
                  v-if="debt.deadline">
                {{ $t('debts.deadline') }} {{ debt.deadline | dateFormat }}
              </span>
              <span
                  class="badge badge-pill badge-danger pull-right"
                  v-if="debt.deleted_at">
                {{ $t('app.in_the_archive') }}
              </span>
              <span
                  class="badge badge-pill badge-primary pull-right"
                  v-if="debt.step">
                Шаг {{ debt.step }}
              </span>
            </div>
          </div>
          <div class="block-content p-0">
            <table class="table table-hover table-vcenter">
              <tbody>
              <tr>
                <th>{{ $t('debtors.fullname') }}</th>
                <td>{{ debt.debtor.fullname }}</td>
              </tr>
              <tr v-if="debt.company_id" class="bg-success">
                <th>{{ $t('debts.company_info') }}</th>
                <td><strong class="text-white">{{ debt.company.name }}</strong></td>
              </tr>
              <tr>
                <th>{{ $t('debtors.iin') }}</th>
                <td>{{ debt.debtor.iin }}</td>
              </tr>
              <tr>
                <th>{{ $t('debtors.birth_day') }}</th>
                <td>{{ debt.debtor.birth_day | dateFormat }}</td>
              </tr>
              <tr>
                <th>{{ $t('debts.current_arrears') }}</th>
                <td>{{ debt.current_arrears }} <span v-if="debt.currency">{{ debt.currency }}</span></td>
              </tr>
              <tr v-if="debt && debt.debtor && (debt.debtor.id_card_number || debt.debtor.id_card_start_date || debt.debtor.id_card_who_issued)">
                <th>{{ $t('debtors.data_from_id_card') }}</th>
                <td>
                  <strong v-if="debt.debtor.id_card_number">{{ $t('debtors.id_card_number') }}:</strong>
                  {{ debt.debtor.id_card_number }}<br>
                  <strong v-if="debt.debtor.id_card_start_date">{{ $t('debtors.id_card_start_date') }}:</strong>
                  {{ debt.debtor.id_card_start_date | dateFormat }}<br>
                  <strong v-if="debt.debtor.id_card_who_issued">{{ $t('debtors.id_card_who_issued') }}:</strong>
                  {{ debt.debtor.id_card_who_issued }}
                </td>
              </tr>
              <tr v-if="debt && debt.debtor && debt.debtor.addresses">
                <th>{{ $t('addresses.last_added') }}</th>
                <td>
                  <template v-for="address in debt.debtor.addresses">
                    <span :key="address.id">
                      <strong>{{ address.type.name }}</strong>: {{ address.address }} <br>
                    </span>
                  </template>
                </td>
              </tr>
              <tr v-if="debt && debt.debtor.work_places.length > 0">
                <th>{{ $t('workplaces.index') }}</th>
                <td>{{ debt.debtor.work_places[0].name }}</td>
              </tr>
              <tr v-if="debt && debt.debtor.work_places.length > 0">
                <th>{{ $t('field.role') }}</th>
                <td>{{ debt.debtor.work_places[0].position }}</td>
              </tr>
              <tr>
                <th>{{ $t('debts.number') }}</th>
                <td>{{ debt.number }}</td>
              </tr>
              <tr>
                <th>{{ $t('debts.product_name') }}</th>
                <td>{{ debt.product_name }}</td>
              </tr>
              <tr>
                <th>{{ $t('field.contragent') }}</th>
                <td>{{ debt.contragent ? debt.contragent.name : '' }}</td>
              </tr>
              <tr v-if="debt.bank_account">
                <th>{{ $t('debts.bank_account') }}</th>
                <td>{{ debt.bank_account }}</td>
              </tr>
              <tr v-if="debt.code">
                <th>{{ $t('debts.code') }}</th>
                <td>{{ debt.code }}</td>
              </tr>
              <tr>
                <th>{{ $t('debts.delay_credit_day') }}</th>
                <td>{{ debt.delay_credit_day }}</td>
              </tr>
              <tr>
                <th>{{ $t('debts.registry_date') }}</th>
                <td>{{ debt.registry_date | dateFormat }}</td>
              </tr>
              <tr>
                <th>{{ $t('debts.additional_data') }}</th>
                <td>{{ debt.additional_data }}</td>
              </tr>
              <tr class="text-center" v-if="isProcessing">
                <th :colspan="2">
                  <loader-wave/>
                </th>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-5">
        <div class="col-md-12">
          <div class="block block-rounded block-bordered block-themed">
            <div class="block-header block-header-default">
              <h3 class="block-title">{{ $t('app.debt_information') }}</h3>
            </div>
            <div class="block-content p-0">
              <table class="table table-bordered table-vcenter mb-0" style="background-color:#fff">
                <tbody>
                <tr>
                  <th>{{ $t('debts.current_arrears') }}</th>
                  <td>{{ debt.current_arrears }}</td>
                </tr>
                <tr v-if="debt.risk_amount > 0 && debt.risk_date >= today" class="bg-danger">
                  <th class="bg-danger text-white">{{ $t('debts.risk_amount') }}</th>
                  <td><strong class="text-white">{{ debt.risk_amount }}</strong></td>
                </tr>
                <tr v-if="debt.amount_allowed" class="bg-success">
                  <th>{{ $t('debts.amount_allowed') }}</th>
                  <td>{{ debt.amount_allowed }}</td>
                </tr>
                <tr v-if="debt.amount_credit">
                  <th>{{ $t('debts.amount_credit') }}</th>
                  <td>{{ debt.amount_credit }}</td>
                </tr>
                <tr v-if="debt.amount_fine">
                  <th>{{ $t('debts.amount_fine') }}</th>
                  <td>{{ debt.amount_fine }}</td>
                </tr>
                <tr v-if="debt.amount_main_debt">
                  <th>{{ $t('debts.amount_main_debt') }}</th>
                  <td>{{ debt.amount_main_debt }}</td>
                </tr>
                <tr>
                  <th>{{ $t('debts.payment_amount') }}</th>
                  <td>{{ debt.payment_amount }}</td>
                </tr>
                <tr>
                  <th>{{ $t('app.total') }}</th>
                  <td>{{ debt.current_arrears }}</td>
                </tr>
                <tr v-if="debt.late_due_date">
                  <th>{{ $t('debts.late_due_date') }}</th>
                  <td>{{ debt.late_due_date }}</td>
                </tr>
                <tr v-if="debt.delay_credit_day">
                  <th>{{ $t('debts.delay_credit_day') }}</th>
                  <td>{{ debt.delay_credit_day }}</td>
                </tr>
                <tr v-if="debt.category_day">
                  <th>{{ $t('debts.category_day') }}</th>
                  <td>{{ debt.category_day }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-md-12">

          <div class="block block-rounded block-bordered block-themed">
            <div class="block-header block-header-default">
              <h3 class="block-title">{{ $t('app.credit_information') }}</h3>
            </div>
            <div class="block-content p-0">
              <table class="table table-bordered table-vcenter mb-0" style="background-color:#fff">
                <tbody>

                <tr v-if="debt.filial">
                  <th>{{ $t('debts.filial') }}</th>
                  <td>{{ debt.filial }}</td>
                </tr>
                <tr v-if="debt.currency">
                  <th>{{ $t('debts.currency') }}</th>
                  <td>{{ debt.currency }}</td>
                </tr>
                <tr v-if="debt.product_name">
                  <th>{{ $t('debts.product_name') }}</th>
                  <td>{{ debt.product_name }}</td>
                </tr>
                <tr>
                  <th>{{ $t('debts.payment_length') }}</th>
                  <td>{{ debt.payment_length }}</td>
                </tr>
                <tr>
                  <th>{{ $t('debts.start_date') }}</th>
                  <td>{{ debt.start_date | dateFormat }}</td>
                </tr>
                <tr>
                  <th>{{ $t('debts.end_date') }}</th>
                  <td>{{ debt.end_date | dateFormat }}</td>
                </tr>
                <tr v-if="debt.amount_credit">
                  <th>{{ $t('debts.amount_credit') }}</th>
                  <td>{{ debt.amount_credit }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {mapGetters} from 'vuex';

export default {
  data() {
    return {
      isProcessing: false,
      today: moment().format('YYYY-MM-DD'),
    };
  },
  computed: {
    ...mapGetters([
      'debt',
    ]),
  },
  components: {
    DebtorPhotos: () => import('@/components/employee/debt/photos'),
  },
};
</script>

<style lang="css" scoped>
.table tbody th {
  text-align: right;
  background: #e5e5e5;
}
</style>
